import { type FC, useMemo } from 'react';

import { Badge } from '../../../../atoms';
import { cn } from '../../../../utils';
import { useAdvancedFiltersStateContext } from '../providers/AdvancedFiltersStateProvider';
import { useGeneralFiltersStateContext } from '../providers/GeneralFiltersStateProvider';
import { getSelectedFiltersCount } from '../utilities/FiltersDrawer.utils';

interface Props {
  additionalFiltersCount?: number;
}

export const SelectedFiltersCountBadge: FC<Props> = ({
  additionalFiltersCount,
}) => {
  const { selectedGeneralFilters } = useGeneralFiltersStateContext();
  const { selectedAdvancedFilters } = useAdvancedFiltersStateContext();

  const totalSelectedFiltersCount = useMemo(
    () =>
      getSelectedFiltersCount(selectedGeneralFilters, selectedAdvancedFilters) +
      (additionalFiltersCount ?? 0),
    [selectedGeneralFilters, selectedAdvancedFilters, additionalFiltersCount],
  );
  if (!totalSelectedFiltersCount) {
    return null;
  }

  return (
    <Badge
      className={cn(
        'absolute -top-2.5 -right-2.5 z-10',
        'rounded-full border-2 border-background',
        'pointer-events-none',
        'min-w-6 h-6 px-1.5',
      )}
    >
      {totalSelectedFiltersCount > 99 ? '99+' : totalSelectedFiltersCount}
    </Badge>
  );
};
